import { defineStore } from 'pinia'

export const useSlimFaceStore = defineStore('slimFace', {
	state: () => ({
		result: null,
		originalImageUrl: null,
		skipped: false,
	}),

	actions: {
		setResult(result) {
			this.result = result
		},
		setOriginalImage(url) {
			this.originalImageUrl = url
		},
		setSkipped(value) {
			this.skipped = value
		},
	},

	getters: {
		getResult: (state) => state.result,
		getOriginalImage: (state) => state.originalImageUrl,
		getSkipped: (state) => state.skipped,
	},
})
